const state = {
  snackbar_text: null,
}

const mutations = {
  SNACKBAR_TEXT(state, text) {
    state.snackbar_text = text
  },
}

const actions = {
  updateSnackbarText({ commit }, text) {
    commit('SNACKBAR_TEXT', text)
    setTimeout(() => commit('SNACKBAR_TEXT', null), 3000)
  },
}

const getters = {
  getSnackbarText: state => state.snackbar_text,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
